import moment from 'moment';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import t from './TodoList.type';
import { getSeasons, getSupplier, getUserSuppliers as getUserSuppliersService } from '../../../../../services/supplierSuggestion.service';
import { getAllBrands, getAllCategory } from '../../../../../services/supplier.service';
import { getSampleRequestsTodoListService, getTodolistCountService, exportExcelService, exportToPdfService } from '../../../../../services/todo-list.service';
import { saveBulkTrackingdates, bulkUpdateSamplePriority as bulkUpdateSamplePriorityService, bulkUpdateSampleStatus as bulkUpdateSampleStatusService, getMainSamples as getMainSamplesService, getOtherSamples as getOtherSamplesService, getSampleTraking as getSampleTrakingService } from '../../../../../services/sample.service';
import { getAllSampleStatus } from '../../../../../services/SystemMaster.services';
import { getMyTodoCount } from '../../../../../services/my-todo.service.ts';

export const getSeasonsAction = (id) => async () => {
  try {
    const res = await getSeasons(id);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveBulkTrackingDates = (data) => async () => {
  try {
    const res = await saveBulkTrackingdates(data);
    if (res) {
      return res.data ?? res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveBulkSamplePriority = (sampleIds, priority) => async () => {
  try {
    const res = await bulkUpdateSamplePriorityService(sampleIds, priority);
    if (res?.data?.code === 200) {
      return res.data ?? res;
    }
    toasterMsg(res?.data?.errMsg ?? 'Failed to update priority', 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveBulkSampleStatus = (sampleIds, statusId) => async () => {
  try {
    const res = await bulkUpdateSampleStatusService(sampleIds, statusId);
    if (res?.data?.code === 200) {
      return res.data ?? res;
    }
    toasterMsg(res?.data?.errMsg ?? 'Failed to update status', 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllBrandAction = (params) => async () => {
  try {
    const res = await getAllBrands(params);
    if (res.code === 200 && res.data) {
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSuppliers = (data) => async () => {
  try {
    const res = await getSupplier(data);
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getUserSuppliers = () => async () => {
  try {
    const res = await getUserSuppliersService();
    if (res.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getMainSamples = (pramams) => async (dispatch) => {
  try {
    const res = await getMainSamplesService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_MAIN_SAMPLES,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getOtherSamples = (pramams) => async (dispatch) => {
  try {
    const res = await getOtherSamplesService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_OTHER_SAMPLES_TODO_LIST,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSampleStatus = (params) => async () => {
  try {
    const res = await getAllSampleStatus(params);
    return res.data;
  } catch (error) {
    toasterMsg(error.message, 'danger');
  }
};

export const fetchCategoryAction = (params) => async (dispatch) => {
  const setValueObj = (label, value) => {
    return { label, value };
  };
  try {
    const res = await getAllCategory(params);
    if (res.code === 200 && res.data) {
      const category = await res.data.map((item) => {
        return setValueObj(item.label, item.value);
      });
      await dispatch({
        type: t.CATEGORY,
        payload: category,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSampleTraking = () => async () => {
  try {
    const res = await getSampleTrakingService();
    if (res?.code === 200) {
      return res.data;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (error) {
    toasterMsg(error.toString(), 'danger');
  }
};

export const getSampleRequestsTodoList = (pramams) => async (dispatch) => {
  const requestId = pramams.requestId || Date.now().toString();
  try {
    const res = await getSampleRequestsTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SAMPLE_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
          requestId,
        },
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_FILTER_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getTodolistCount = (pramams) => async (dispatch) => {
  try {
    let res;
    if (pramams.type === 'my-todo') {
      res = await getMyTodoCount();
      if (res?.code === 200) {
        const count =
          typeof res.data === 'number'
            ? res.data
            : res.data?.myTodoCount ?? res.data?.count ?? 0;
        const allTodoCount =
          typeof res.data === 'number'
            ? res.data
            : res.data?.allTodoCount ?? count;
        await dispatch({
          type: t.SET_TODO_LIST_COUNT,
          payload: {
            totalCount: count,
            colour: '#6C757D',
            type: pramams.type,
          },
        });
        await dispatch({
          type: 'FETCH_MY_TODO_COUNT',
          payload: { pendingCount: count, allTodoPendingCount: allTodoCount },
        });
        return true;
      }
    } else {
      res = await getTodolistCountService(pramams);
      if (res?.code === 200) {
        await dispatch({
          type: t.SET_TODO_LIST_COUNT,
          payload: {
            totalCount: res.data.totalCount,
            colour: res.data.colour,
            type: pramams.type,
          },
        });
        return true;
      }
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

const downloadFromUrl = (fileUrl, fileName) =>
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      const fileObjectURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileObjectURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(fileObjectURL);
    });

export const exportExcel = (params) => async () => {
  try {
    const response = await exportExcelService({
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    if (response?.data?.zipUrl) {
      const fileName = response.data.fileName || `Sample Report - ${moment().format('DD-MM-YYYY')}.xlsx`;
      await downloadFromUrl(response.data.zipUrl, fileName);
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setSampleSelectedIds = (idsArr) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SELECTED_IDS_ARRAY,
      payload: idsArr,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportToPdf = (params) => async () => {
  try {
    const res = await exportToPdfService({
      ...params,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    if (res?.data?.fileName && res?.data?.zipUrl) {
      const fileName = res.data.fileName.toString();
      await downloadFromUrl(res.data.zipUrl, fileName);
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
